export const Script = () => {
  const existingScript = document.getElementById("seobix-script");

  if (existingScript) return;

  const seoScript = document.createElement("script");

  seoScript.id = "seobix-script";
  seoScript.src =
    "https://packky.com/SeoBix/seo_injection.php" +
    "?webid=cd8435ad15b4e27805d9e08fbaa8d536" +
    "&url=" +
    encodeURIComponent(window.location.href) +
    "&baseUrl=" +
    encodeURIComponent(window.location.origin);

  seoScript.async = true;
  seoScript.defer = true;

  document.head.appendChild(seoScript);
};